import styled from 'styled-components';
import { colors, breakPoints } from '@/styles';

export const DirectoryEntry = styled.div`
  display: grid;
  gap: 25px;
  grid-template-columns: 1fr 65px 1fr 110px 100px;
  align-items: center;

  padding: 0 15px;
  height: 40px;
  border: 1px solid ${colors.secondary.lightGray2};

  &:hover {
    background: ${colors.secondary.lightGray1};
  }

  & > .filesize {
    display: flex;
    text-transform: lowercase;
    justify-content: flex-end;
  }

  @media (max-width: ${breakPoints.tabletPortrait}) {
    grid-template-columns: 2fr 70px 1fr 40px 100px;
    .data-type-badge {
      & > span {
        display: none;
      }
    }
  }

  @media (max-width: ${breakPoints.mobilePortrait}) {
    grid-template-columns: 2fr 75px 1fr 40px 100px;
  }

  @media (max-width: ${breakPoints.mobile}) {
    grid-template-columns: 1fr 0 0 0 0;
    gap: 0;
    :nth-child(3) {
      display: none;
    }
    :nth-child(4) {
      display: none;
    }
    :nth-child(5) {
      display: none;
    }
    :nth-child(6) {
      display: none;
    }
  }
`;

export const File = styled.span`
  display: grid;
  grid-template-columns: 16px 1fr;
  align-items: center;
  gap: 10px;

  span.filename {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const CommitMessage = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const FileType = styled.div``;

export const TimeAgo = styled.span`
  text-align: right;
  white-space: nowrap;
  overflow: hidden;
`;
